import { useState } from 'react';
import axios from 'axios';
import { axiosApi } from '../../api/setupApi';

const useDeleteNISfsResult = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const deleteNISfsResult = async (id) => {
    setLoading(true);
    setError(null);
    setSuccessMessage(null);

    try {
  const response = await axiosApi.delete(`/nisfsResult/delete/${id}`);
      setSuccessMessage(response.data.message || 'Deleted successfully');
      console.log(`Deleted NIS FS Result data with id: ${id}`);
      return response.data; // Return response data for caller if needed
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to delete NIS Fs Result');
      console.error('Delete error:', err);
    } finally {
      setLoading(false);
    }
  };

  return { deleteNISfsResult, loading, error, successMessage };
};

export default useDeleteNISfsResult;
